var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.deliverables.length
    ? _c(
        "action-card",
        {
          attrs: {
            title: _vm.taskMode
              ? _vm.$t("projects.tasks")
              : _vm.$t("nav.projects"),
            icon: _vm.taskMode ? "clipboard-list" : "folder-kanban",
            count: _vm.deliverables.length
          },
          on: {
            open: function($event) {
              return _vm.$router.push("/projects")
            }
          }
        },
        _vm._l(_vm.visibleDeliverables, function(deliverable) {
          return _c(
            "button",
            {
              key: deliverable.id,
              staticClass: "portal-action-row",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.openDeliverable(deliverable)
                }
              }
            },
            [
              _c("span", { staticClass: "action-row-copy" }, [
                _c("strong", [_vm._v(_vm._s(deliverable.name))]),
                _vm.taskMode && _vm.taskContext(deliverable)
                  ? _c("small", [_vm._v(_vm._s(_vm.taskContext(deliverable)))])
                  : _vm._e()
              ]),
              _c("portal-icon", { attrs: { name: "chevron-right", size: 18 } })
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }